import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setNavigateFunction } from "../../utils/navigation.util";

const NavigationInjector = () => {
    const navigate = useNavigate();

    useEffect(() => {
        setNavigateFunction(navigate);
    }, [navigate])
    return null
}

export default NavigationInjector
